import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import GameDescriptionHeader from '../components/layout/header/GameDescriptionHeader';
import Footer from '../components/layout/Footer';
import { IoPersonCircle } from 'react-icons/io5';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';
import { IsAuth } from '../utils/Auth';
import { useLocation } from 'react-router';
import axios from 'axios';
const GameDescription = () => {
  const location = useLocation();
  const id = location.pathname.split('/')[2];
  console.log(id);
  const [event, setEvent] = useState({});

  useEffect(() => {
    const getSingleEvent = async () => {
      try {
        const res = await axios.get(`/api/v1/events/${id}`);
        console.log(res.data.data);
        setEvent(res.data.data);
      } catch (error) {}
    };
    getSingleEvent();
  }, [id]);

  const { game, description, poolAmount, markUp, team1, team2 } = event;
  console.log(team1);
  if (team1 !== undefined) {
    // const t1 = team1.map((team) => team);
    var player1 = team1[0].player1;
    console.log(player1);
  }
  if (team2 !== undefined) {
    var player2 = team2[0].player2;
    console.log(player2);
  }

  return (
    <div>
      <GameDescriptionHeader />
      <div className='container-fluid'>
        <div className='mx-md-5 px-4 my-md-5 py-5'>
          <h2 className='fw-bold'>{game}</h2>
          <h2 className='fw-bold'>(Shutout Stack, Right Hand Match )</h2>
          <h5 className='fw-bold pt-5'>Game Description</h5>
          <p className='pt-md-4'>{description}</p>
          <div className='d-lg-flex justify-content-between mt-md-5 pt-4'>
            <div className='d-md-flex gap-3'>
              <p className=' poolamt2Text p-2'>
                Pool Amount &nbsp; &nbsp; &nbsp; &nbsp; Rs {poolAmount}/-
              </p>
              <p className='markup2Text p-2'>
                Mark Up &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {markUp}
              </p>
            </div>
            <div className='col-xs-12'>
              <div className='datetimeText p-2 text-center'>
                <h5 className='fw-bold pt-1'>
                  DATE : 23/09/2021 &nbsp; | &nbsp; TIME : 12.00 PM
                </h5>
              </div>
            </div>
          </div>
          <h2 className='fw-bold pt-md-5 mt-5'>Players List</h2>
          <div className='d-xl-flex gap-5 mb-5'>
            <div
              style={{
                backgroundColor: '#f9f9f9',
                boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                maxHeight: '88vh',
              }}
              className='border-0 mt-5 px-4 py-5'
            >
              <div className='d-flex flex-column'>
                <div className='d-flex justify-content-between align-items-center'>
                  <IoPersonCircle color='#432344' size={123} />
                  <div className='d-flex flex-column me-md-4 pe-3'>
                    <p className=' poolamt2Text p-2'>
                      Pool Amount &nbsp; &nbsp; &nbsp; &nbsp; Rs {poolAmount}/-
                    </p>
                    <p className='markup2Text p-2'>
                      Mark Up &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {markUp}
                    </p>
                  </div>
                </div>
                <div className='d-flex flex-column p-3 pt-md-4'>
                  <div className='d-flex gap-5'>
                    <h4 className='playernameText'>Player Name</h4>
                    <h6 className=''>{player1}</h6>
                  </div>
                  <div className='d-flex gap-5 py-md-4 my-md-3'>
                    <h4 className='playernameText'>Rating</h4>
                    <div className='d-flex gap-md-2 ms-5 stars'>
                      <FaStar color='#FDDC30' size={27} />
                      <FaStar color='#FDDC30' size={27} />
                      <FaStar color='#FDDC30' size={27} />
                      <FaStar color='#FDDC30' size={27} />
                      <FaStarHalfAlt color='#FDDC30' size={27} />
                    </div>
                  </div>
                  <div className='d-flex gap-5'>
                    <h4 className='playernameText'>Game Win</h4>
                    <h6 className='ms-3 ps-1'>30</h6>
                  </div>
                  <div className='d-md-flex gap-5 py-md-4 my-md-3'>
                    <h4 className='playernameText'>Player Info</h4>
                    <h6 className='ms-md-3 ps-1'>
                      Lorem Ipsum is simply dummy text <br />
                      of the printing and typesetting <br />
                      industry. lorem Ipsum has been the <br />
                      industry's standard dummy text
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: '#f9f9f9',
                boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                maxHeight: '88vh',
              }}
              className='border-0 mt-5 px-4 py-5'
            >
              <div className='d-flex flex-column'>
                <div className='d-flex justify-content-between align-items-center'>
                  <IoPersonCircle color='#432344' size={123} />
                  <div className='d-flex flex-column me-4 pe-md-3'>
                    <p className=' poolamt2Text p-2'>
                      Pool Amount &nbsp; &nbsp; &nbsp; &nbsp; Rs {poolAmount}/-
                    </p>
                    <p className='markup2Text p-2'>
                      Mark Up &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {markUp}
                    </p>
                  </div>
                </div>
                <div className='d-flex flex-column p-3 pt-md-4'>
                  <div className='d-flex gap-5'>
                    <h4 className='playernameText'>Player Name</h4>
                    <h6>{player2}</h6>
                  </div>
                  <div className='d-flex gap-5 py-md-4 my-md-3'>
                    <h4 className='playernameText'>Rating</h4>
                    <div className='d-flex gap-md-2 ms-5 stars'>
                      <FaStar color='#FDDC30' size={27} />
                      <FaStar color='#FDDC30' size={27} />
                      <FaStar color='#FDDC30' size={27} />
                      <FaStar color='#FDDC30' size={27} />
                    </div>
                  </div>
                  <div className='d-flex gap-5'>
                    <h4 className='playernameText'>Game Win</h4>
                    <h6 className='ms-3 ps-1'>50</h6>
                  </div>
                  <div className='d-md-flex gap-5 py-md-4 my-md-3'>
                    <h4 className='playernameText'>Player Info</h4>
                    <h6 className='ms-md-3 ps-1'>
                      Lorem Ipsum is simply dummy text <br />
                      of the printing and typesetting <br />
                      industry. lorem Ipsum has been the <br />
                      industry's standard dummy text
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GameDescription;
